import React from 'react';
import { Clock, Trash } from 'lucide-react';
import { format } from 'date-fns';
import { Meal } from '../../types/nutrition';
import { useMealStore } from '../../store/mealStore';

interface MealSummaryProps {
  meal: Meal;
}

export function MealSummary({ meal }: MealSummaryProps) {
  const { removeMeal } = useMealStore();
  
  const totalCalories = meal.foods.reduce((sum, food) => 
    sum + food.calories * (food.servings || 1), 0
  );
  
  const totalProtein = meal.foods.reduce((sum, food) => 
    sum + (food.protein || 0) * (food.servings || 1), 0
  );
  
  const totalCarbs = meal.foods.reduce((sum, food) => 
    sum + (food.carbs || 0) * (food.servings || 1), 0
  );
  
  const totalFat = meal.foods.reduce((sum, food) => 
    sum + (food.fat || 0) * (food.servings || 1), 0
  );

  return (
    <div className="theme-card p-4 space-y-3 relative group">
      <div className="flex items-center justify-between">
        <div>
          <div className="font-medium capitalize">{meal.type}</div>
          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <Clock className="w-3 h-3" />
            <span>{format(new Date(meal.time), 'h:mm a')}</span>
          </div>
        </div>
        <div className="text-right">
          <div className="font-medium">{Math.round(totalCalories)} cal</div>
          <div className="text-xs text-muted-foreground">
            P: {Math.round(totalProtein)}g • C: {Math.round(totalCarbs)}g • F: {Math.round(totalFat)}g
          </div>
        </div>
      </div>

      <div className="space-y-2">
        {meal.foods.map((food, index) => (
          <div key={index} className="flex justify-between text-sm">
            <div className="flex items-center gap-2">
              <span>{food.emoji}</span>
              <span>{food.name}</span>
              {(food.servings || 0) > 1 && (
                <span className="text-xs text-muted-foreground">
                  x{food.servings}
                </span>
              )}
            </div>
            <div className="text-muted-foreground">
              {Math.round(food.calories * (food.servings || 1))} cal
            </div>
          </div>
        ))}
      </div>

      {/* Delete Button */}
      <button
        onClick={() => removeMeal(meal.id)}
        className="absolute -right-2 -top-2 p-1.5 rounded-full bg-destructive/10 text-destructive opacity-0 group-hover:opacity-100 transition-opacity hover:bg-destructive/20"
      >
        <Trash className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}